import connect from "@classdojo/web/utils/hoc/connect";
import GroupsDisplay from "./GroupsDisplay";
import { Group, GroupsSlice, appMetadataGroups, selectBaseAvatarURL, selectGroups } from "src/pods/groups";
import { displayClose } from "src/pods/realtime";
import PresentationPage from "src/shared/components/PresentationPage";

type GroupsDisplayContainerProps = {
  baseAvatarURL: string | null;
  groups: Group[];
  isReceiver: boolean;
  displayClose: typeof displayClose;
};
const mapStateToProps = (state: GroupsSlice) => {
  return {
    baseAvatarURL: selectBaseAvatarURL(state),
    groups: selectGroups(state),
    isReceiver: true,
  };
};
const mapDispatchToProps = {
  displayClose,
};
export default connect(
  mapStateToProps,
  mapDispatchToProps,
)((props: Partial<GroupsDisplayContainerProps>) => (
  <PresentationPage backgroundColor={appMetadataGroups().backgroundColor} onRequestHide={props.displayClose}>
    <GroupsDisplay groups={props.groups} isReceiver={props.isReceiver} baseAvatarURL={props.baseAvatarURL} />
  </PresentationPage>
));
